import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex fill-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_parameter_card = _resolveComponent("parameter-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_parameter_card, {
      class: "parameter-card",
      title: 
        _ctx.t('parameter.selected_parameters') +
          ` (${_ctx.parameterStore.selectedParameters.length}/${_ctx.parameterStore.allParameters.length})`
      ,
      items: _ctx.parameterStore.allParameters,
      selected: _ctx.parameterStore.selectedParameters,
      onSelectedChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectParams($event)))
    }, null, 8, ["title", "items", "selected"])
  ]))
}